import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import {BehaviorSubject, Observable} from 'rxjs';
import {retry} from 'rxjs/operators';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {UrlProviderService} from '../../../shared/services/general';
import {SECURED_STORE} from '../../../shared/utils';
import {Diagnosis} from '../models/common';
import {SearchableService} from './searchable.service';

@Injectable()
export class DiagnosisService implements SearchableService {
  constructor(
    private urlProvider: UrlProviderService,
    private router: Router,
    private httpClient: HttpClient,
    private fusionAuthService: FusionAuthService,
  ) {
    this.customStore = this.customStore.bind(this);
  }

  public search(value: any): Observable<Diagnosis> {
    const filter = JSON.stringify(['code', '=', value]);
    return this.httpClient.get<Diagnosis>(`${this.urlProvider.ApiUrl}/v2/diagnoses/remote-operations?filter=${filter}`)
      .pipe(retry(2));
  }

  public customStore(dataSource: BehaviorSubject<DataSource>): CustomStore {
    return SECURED_STORE({
      loadUrl: `${this.urlProvider.ApiUrl}/v2/diagnoses/remote-operations`,
      routerService: this.router,
      dataSource,
      loadParams: null,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT()
    });
  }

  public customStoreFilteredByPatientId(patientId: number, dataSource: BehaviorSubject<DataSource>): CustomStore {
    return SECURED_STORE({
      loadUrl: `${this.urlProvider.ApiUrl}/v2/diagnoses/remote-operations/filter-by-patient-id?patientId=${patientId}`,
      routerService: this.router,
      dataSource,
      loadParams: null,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT()
    });
  }
}
